import { all, fork, put, takeLatest, call } from 'redux-saga/effects';
import { TagSearchActionTypes } from './constants';
import { tagSearch } from './api';
import { toast } from 'react-toastify';

function* tagSearchGetFunction(data) {
    try {
        yield put({ type: TagSearchActionTypes.TAG_SEARCH_DATA_LOADING, payload: {} });
        const response = yield call(tagSearch, data);
        if (response.data.status) {
            yield put({ type: TagSearchActionTypes.TAG_SEARCH_DATA_SUCCESS, payload: response.data });
        } else {
            toast.error(response.data.message);
            yield put({ type: TagSearchActionTypes.TAG_SEARCH_DATA_ERROR, payload: response.data });
        }
    } catch (error) {
        yield put({ type: TagSearchActionTypes.TAG_SEARCH_DATA_ERROR, payload: error });
    }
}

export function* watchTagSearchData() {
    yield takeLatest(TagSearchActionTypes.TAG_SEARCH_DATA_FIRST, tagSearchGetFunction);
}

function* tagSearchSaga() {
    yield all([fork(watchTagSearchData)]);
}
export default tagSearchSaga;
